interface SplashScreenProps {
  message?: string;
  appName?: string;
}

export function SplashScreen({ message = 'Loading…', appName = 'Demo App' }: SplashScreenProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background">
      <div className="flex size-16 shrink-0 items-center justify-center rounded-2xl bg-sidebar-foreground text-sidebar text-xl font-bold shadow-lg">
        AR
      </div>

      <div className="flex flex-col items-center gap-1">
        <p className="text-lg font-semibold tracking-tight text-foreground">{appName}</p>
        <p className="text-sm text-muted-foreground">{message}</p>
      </div>

      <span
        role="status"
        aria-label={message}
        className="size-6 animate-spin rounded-full border-2 border-current/20 border-t-primary"
      />
    </div>
  );
}
